import { ca } from '@cian/analytics';
import { TPlatform } from 'shared/types/platform';

export function trackButtonClick(platform: TPlatform, buttonName: string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'Promo_cian_apps',
    label: platform === 'ios' ? 'app_iOS' : 'app_android',
    page: { extra: { buttonName } },
  });
}
